<action-modal
	modalTitle="{{ Loc(LocalizedTextIds.LargeDownloadModalLarge) }}"
	[actionOptions]="ActionOptions"
	maxHeight="250"
	(action)="handleAction($event)"
>
	<p class="large-download-modal-description">
		{{ Loc(LocalizedTextIds.LargeDownloadModalNavigator) }}
	</p>
</action-modal>
